import { c as _c } from "react/compiler-runtime";
import { SearchFieldPropertiesType } from "@website/ui/search-field/search-field.types";
import { useRef } from "react";
export const useSearchField = properties => {
  const $ = _c(29);
  const {
    autoFocus,
    "aria-label": ariaLabel,
    disabled,
    inputMode,
    maxLength,
    onChange,
    placeholder,
    value,
    onFocus,
    onBlur,
    onSubmit,
    onStartIconClick,
    onEndIconClick,
    onKeyDown,
    defaultValue,
    ref
  } = properties;
  const temporaryReference = useRef(null);
  const inputReference = ref || temporaryReference;
  let t0;
  if ($[0] !== inputReference) {
    const onRootClick = () => {
      inputReference.current?.focus();
    };
    t0 = {
      onClick: onRootClick
    };
    $[0] = inputReference;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== ariaLabel || $[3] !== autoFocus || $[4] !== defaultValue || $[5] !== disabled || $[6] !== inputMode || $[7] !== inputReference || $[8] !== maxLength || $[9] !== onBlur || $[10] !== onChange || $[11] !== onFocus || $[12] !== onKeyDown || $[13] !== placeholder || $[14] !== value) {
    t1 = {
      autoFocus,
      "aria-label": ariaLabel,
      ref: inputReference,
      disabled,
      inputMode,
      maxLength,
      onChange,
      placeholder,
      value,
      onFocus,
      onBlur,
      onKeyDown,
      defaultValue
    };
    $[2] = ariaLabel;
    $[3] = autoFocus;
    $[4] = defaultValue;
    $[5] = disabled;
    $[6] = inputMode;
    $[7] = inputReference;
    $[8] = maxLength;
    $[9] = onBlur;
    $[10] = onChange;
    $[11] = onFocus;
    $[12] = onKeyDown;
    $[13] = placeholder;
    $[14] = value;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== disabled || $[17] !== onSubmit) {
    t2 = {
      tabIndex: -1,
      onClick: onSubmit,
      disabled
    };
    $[16] = disabled;
    $[17] = onSubmit;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== onStartIconClick) {
    t3 = {
      onClick: onStartIconClick
    };
    $[19] = onStartIconClick;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== onEndIconClick) {
    t4 = {
      onClick: onEndIconClick
    };
    $[21] = onEndIconClick;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== t0 || $[24] !== t1 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4) {
    t5 = {
      rootProps: t0,
      inputProps: t1,
      submitButtonProps: t2,
      startIconProperties: t3,
      endIconProperties: t4
    };
    $[23] = t0;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
};